/**
* @file 系统设置-后台账号
* */
<template>
  <div id="backgroundAccount">
    <tab-frame :tabs="tabs"></tab-frame>
  </div>
</template>

<script>
export default {
  name: "backgroundAccount",
  data() {
    return {
      // tabs列表
      tabs: [
        { label: "账号管理", name: "/member" },
        { label: "角色权限", name: "/role" },
        { label: "菜单管理", name: "/menuManage" },
      ],
    };
  },
};
</script>

